// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductTag_root__12VGQ","label":"ProductTag_label__2dd0B"};